module.exports = __webpack_public_path__ + "static/media/Moira.9db3af57.jpg";